import { render, staticRenderFns } from "./overSpeedDetail.vue?vue&type=template&id=220c6654&scoped=true&"
import script from "./overSpeedDetail.vue?vue&type=script&lang=js&"
export * from "./overSpeedDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=220c6654&lang=scss&scoped=true&"
import style1 from "./overSpeedDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c6654",
  null
  
)

export default component.exports